import Vue from 'vue'

Vue.component('home', require('./home').default);
Vue.component('pages-404', require('./utility/404').default);

Vue.component("login", require("./account/login").default);
Vue.component("register", require("./account/register").default);
Vue.component("forgot-password", require("./account/forgot-password").default);
Vue.component("reset-password", require("./account/reset-password").default);

Vue.component("utility-tabla", require("./utility/tabla").default);
Vue.component("configuracion-usuarios", require("./configuracion/usuarios").default);
Vue.component("configuracion-crearusuario", require("./configuracion/crearusuario").default);
Vue.component("configuracion-colegios", require("./configuracion/colegios").default);
Vue.component("configuracion-crearcolegio", require("./configuracion/crearcolegio").default);
Vue.component("configuracion-eventos", require("./configuracion/eventos").default);
Vue.component("configuracion-crearevento", require("./configuracion/crearevento").default);
Vue.component("configuracion-laborantes", require("./configuracion/laborantes").default);
Vue.component("configuracion-eventosiniciados", require("./configuracion/eventosiniciados").default);
Vue.component("configuracion-eventolaborantes", require("./configuracion/eventolaborantes").default);
Vue.component("laborantes-agregardigitalizador", require("./laborantes/agregardigitalizador").default);
Vue.component("laborantes-agregarapoyo", require("./laborantes/agregarapoyo").default);
Vue.component("laborantes-agregarsalida", require("./laborantes/agregarsalida").default);
Vue.component("laborantes-apago", require("./laborantes/apago").default);
Vue.component("laborantes-pagos", require("./laborantes/pagos").default);
Vue.component("laborantes-porpagar", require("./laborantes/porpagar").default);
Vue.component("laborantes-todospagos", require("./laborantes/todospagos").default);
Vue.component("laborantes-valorespago", require("./laborantes/valorespago").default);
Vue.component("gastos-agregar", require("./reembolsos/agregar_reembolsos").default);
Vue.component("gastos-ver", require("./reembolsos/ver_reembolsos").default);
Vue.component("gastos-historial", require("./reembolsos/historial_reembolsos").default);
Vue.component("configuracion-cambiarcontraseña", require("./configuracion/cambiarcontraseña").default);
Vue.component("evaluar-coordinador", require("./evaluaciones/evaluar_coordinador").default);
Vue.component("evaluar-laborante", require("./evaluaciones/evaluar_laborante").default);
Vue.component("evaluaciones-coordinadores", require("./evaluaciones/evaluaciones_coordinadores").default);
Vue.component("evaluaciones-laborantes", require("./evaluaciones/evaluaciones_laborantes").default);
Vue.component("actualizacion-usuarioscolegios", require("./actualizacion/usuarios_colegios").default);
Vue.component("digitalizar-asociar", require("./digitalizar/asociar_evento").default);
Vue.component("digitalizar-ver", require("./digitalizar/verdatos").default);
Vue.component("digitalizar-encuesta", require("./digitalizar/digitalizar_encuesta").default);
Vue.component("invitado-listado", require("./usuario_invitado/listado_usuarios").default);
Vue.component("invitado-historial", require("./usuario_invitado/historial").default);
